// extracted by mini-css-extract-plugin
module.exports = {"label":"MultiTextInput_fasting_label__33kD4","input":"MultiTextInput_fasting_input__3WNkZ"};